module.exports = __webpack_public_path__ + "static/media/about1.dbba7108.jpg";